export const CloseCommentEvent = "closeCommentWindow";
